export default "__VITE_ASSET__Cl95NFC0__"